export function computeRecipe(r) {
  const materials = r.materials || [];
  const op = r.operational_costs || [];
  const materialCost = materials.reduce(
    (s, m) => s + (Number(m.price_per_unit) || 0) * (Number(m.quantity) || 0), 0
  );
  const opCost = op.reduce((s, c) => s + (Number(c.amount) || 0), 0);
  const total = materialCost + opCost;
  const units = Number(r.units_produced) || 1;
  const hpp = total / (units || 1);
  const margin = Number(r.margin_percent) || 0;
  const price = hpp * (1 + margin / 100);
  const profitUnit = price - hpp;
  return {
    materialCost, opCost, total, units, hpp, price, margin,
    profitUnit, profitBatch: profitUnit * units,
  };
}
